import { useEffect, useState } from "react";

import axios from "axios";
export const useBcv = () => {

  let op = require("../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");


  const [moneda, setMoneda] = useState({
    idmoneda: "",
    descripcion: "",
    simbolo: "",
    predeterminada: false,
    valormoneda: "0,00",
    subpredeterminada: true,
  });


  const seleccionarRegistros = async () => {
    const campos =
      "m.idmoneda, m.descripcion, m.simbolo, m.predeterminada,  m.subpredeterminada, md.valor as valormoneda, md.fecha";
    const nomtab =
      "moneda as m left join monedadetalle as md on m.idmoneda=md.idmoneda where md.fecha = (SELECT MAX(fecha) AS fecha FROM monedadetalle where idmoneda=m.idmoneda)";
    const orden = "m.idmoneda";

    const endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].subpredeterminada) {
                setMoneda(response.data[i]);
              }
            }
          }
        }
      });
  };


  const actualizarTasa = async () => {
    const endpoint = `${op.conexion}/api/bcv`;
    axios.get(
      endpoint,
      {
        headers: {
          "x-access-token": `${token}`,
        },
      }
    ).then(function (response) {
      if (response.status === 200) {
        console.log("tasa")
        console.log(response.data);
      }
    }).finally(async () => {
      await seleccionarRegistros();
    });
  };

  useEffect(() => {
    actualizarTasa();
    console.log("hola prueba")
  }, []);


  return {
    moneda
  }
};



// WEBPACK FOOTER //
// ./src/hooks/useBcv.js